__turbopack_context__.v({
  "headingText": "bknaiW_headingText",
});
